import type { SecondaryMarketKycResponse } from 'apiConnector/secondary-market/shared/kyc';
import type { SettlementTypesResponse } from 'apiConnector/secondary-market/shared/settlement';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

import type { KycData } from '../../state/secondaryMarket/shared/kyc/kyc.model';
import { mapKycResponse } from '../../state/secondaryMarket/shared/kyc/kyc.model';

export interface SettlementTypesApi {
  getSettlementTypes(
    bcsProductKey: BcsProductKey,
    client: ISalesCounterpart,
    custodianBdrId: string,
  ): Observable<SettlementTypesResponse>;
}

export interface KycStatusApi {
  getKycStatus(clientBdrId: string, salesCountry: string): Observable<KycData>;
}

export function referentialApiConnector(httpClient: IHttpClient): SettlementTypesApi & KycStatusApi {
  return {
    getSettlementTypes: (bcsProductKey, client, custodian) => {
      return httpClient
        .getJSON<SettlementTypesResponse>({
          url: `api/v1/secondary-market/settlement-types`,
          params: {
            bcsSource: bcsProductKey.source,
            bcsSubType: bcsProductKey.subType,
            bcsCode: bcsProductKey.code,
            clientBdrId: client.id,
            clientEliotCode: client.eliotCode,
            custodianBdrId: custodian,
          },
          tryParseErrorPayload: true,
          parseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    getKycStatus(clientBdrId, saleCountry) {
      return httpClient
        .getJSON<SecondaryMarketKycResponse>({
          url: `api/v1/secondary-market/kyc-status`,
          params: {
            saleCountry,
            clientBdrId,
          },
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => mapKycResponse(payload)));
    },
  };
}
